import axios from "axios";
import { getParamsForFetchInventory } from "utils";

export default function fetchInventoryForUserChoices({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ addToOrderValues }) => {
    const params = getParamsForFetchInventory({ addToOrderValues });

    const shopifyRootPath = window?.Shopify?.routes?.root;
    if (typeof shopifyRootPath !== "string") {
      return Promise.reject(new Error("Shopify routes.root is not available."));
    }
    const requestUrl = `${window?.location?.origin}${window?.Shopify?.routes?.root}products/${params}`;

    // ! FOR LOCALDEV ONLY
    // const requestUrl = `${process.env.REACT_APP_SHOPIFY_INVENTORY_URL}/${params}`;

    return axios({
      url: requestUrl,
      method: "GET",
      cancelToken: source.token,
      params: {
        section_id: "product-quickturn-info",
      },
    });
  };
}
